import type { MemberStatus } from "@/api/member/type";

/** 会员状态 Tag 颜色（按 API 枚举） */
export const MEMBER_STATUS_TAG_COLOR: Record<string, string> = {
  ACTIVE: "success",
  INACTIVE: "default",
  DISABLED: "error",
  BLACKLIST: "warning",
};

/**
 * 取会员状态 Tag 颜色
 * @param status 会员状态枚举
 */
export const getMemberStatusTagColor = (status?: MemberStatus | string) =>
  (status && MEMBER_STATUS_TAG_COLOR[status]) || "default";
